
import { Component, Prop, Vue } from "vue-property-decorator";
import { formRules } from "@/utils/formRules";
import SimpleDialog from "@/components/SimpleDialog.vue";

@Component({
  components: { SimpleDialog },
})
export default class UrmetOnboarding extends Vue {

  get canSubmit(): boolean {
    return this.valid;
  }

  @Prop({default: null})
  public buildingId: number;

  @Prop({ default: false })
  private showDialog: boolean;

  private showConfirmation: boolean = false;

  private badgeNumber: string = "";
  private mandate: any = null;
  private loadingAssociate: boolean = false;

  private valid: boolean = true;
  private rules = formRules;

  private closeConfirmation() {
    this.showConfirmation = false;
  }

  private displayConfirmation() {
    this.showConfirmation = true;
  }

  /**
   * Send an association request to Urmet by building ID.
   *
   * @return {Promise<void>} Resolves if the association can be done successfully, otherwise, it throws an error.
   */
  private async associateUrmet(): Promise<void> {
    this.loadingAssociate = true;
    await this.$store.dispatch("buildings/associateUrmetByBuildingId", {
      buildingId: this.buildingId,
      badgeNumber: this.badgeNumber,
      mandate: this.mandate,
    })
      .then((data) => {
        this.$store.commit("alerts/displaySuccess", {
          msg: this.$i18n?.t("Building.onboardingRequested"),
        });
      })
      .catch((error) => {
        this.$store.commit("alerts/displayHttpError", { error });
      })
      .finally(() => { this.loadingAssociate = false;
                       this.closeConfirmation();
                       this.$emit("success");
                       this.$emit("close");
        });
  }
}
